import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=e6027bf4&scoped=true"
import script from "./RoleTree.vue?vue&type=script&setup=true&name=RoleTree&lang=js"
export * from "./RoleTree.vue?vue&type=script&setup=true&name=RoleTree&lang=js"
import style0 from "./RoleTree.vue?vue&type=style&index=0&id=e6027bf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6027bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6027bf4')) {
      api.createRecord('e6027bf4', component.options)
    } else {
      api.reload('e6027bf4', component.options)
    }
    module.hot.accept("./RoleTree.vue?vue&type=template&id=e6027bf4&scoped=true", function () {
      api.rerender('e6027bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/role/permission/RoleTree.vue"
export default component.exports